import instance from './axios'
import { Message } from 'element-ui'
import ssoWeb, { clientId } from '@/lib/SSO'
import { api } from '@/api/apiList'
import { addOwlWarn } from '@bike/fe-owl'

// request拦截器
instance.interceptors.request.use(
  config => {
    config.headers = {
      ...config.headers,
      platform: 'partner',
      'client-id': clientId,
      'x-requested-with': 'XMLHttpRequest',
    }
    if (config.url.indexOf('/') === -1) {
      config.url = api[config.url]
    }
    return config
  },
  err => {
    // Do something with request error
    Message({
      type: 'error',
      message: err.message,
      duration: 3000,
      showClose: true,
    })
    try {
      addOwlWarn({
        name: `[ajax-req-err] ${err.message}`,
        msg: err,
        config: {
          category: 'ajaxError',
        },
      })
    } catch (e) {
      console.error(e)
    }
    return false
  }
)

// response拦截器
instance.interceptors.response.use(
  res => {
    // 兼容 blob 场景
    if (res.config && res.config.responseType === 'blob' && res.data) {
      if (!res.data.size) {
        Message({
          type: 'warning',
          message: '无数据',
          duration: 2000,
          showClose: true,
        })
        return Promise.reject()
      }
      // 出错时候，接口会以Blob形式返回JSON数据，需要将错误信息提取展示
      if (res.data.type === 'application/json') {
        const reader = new FileReader()
        reader.readAsText(res.data)
        reader.onload = event => {
          const result = JSON.parse(event.target.result) || {}
          Message({
            type: 'error',
            message: result.message || '出错啦，请重试或联系管理员',
            duration: 2000,
            showClose: true,
          })
        }
        return Promise.reject()
      }
      // 正常情况
      return Promise.resolve(res)
    }

    // 非 blob 场景
    const resData = res.data || {}
    const code = resData.code
    // 兼容部分状态key为status的接口，后端暂时无法修改
    const status = resData.status

    if (code === 50102) {
      window.location.href = ssoWeb.getLoginUrl()
    } else if (code === 1000 || code === 0 || status === 1000 || status === 0 || status === 1) {
      return Promise.resolve(resData)
    } else {
      if (!(res.config && res.config.hideGlobalMsg)) {
        Message({
          type: 'error',
          message: resData.message || '出错啦，请重试！',
          duration: 2000,
          showClose: true,
        })
      }
      try {
        addOwlWarn({
          name: `[ajax-res] ${resData.message}`,
          msg: {
            traceid: (res.request && res.request.traceid) || '',
            res: res.data,
            config: res.config,
          },
          config: {
            category: 'ajaxError',
          },
        })
      } catch (e) {
        console.error(e)
      }
      return Promise.reject(resData)
    }
  },
  err => {
    Message({
      type: 'error',
      message: err.message,
      duration: -1,
      showClose: true,
    })
    try {
      addOwlWarn({
        name: `[ajax-res-err] ${err.message}`,
        msg: err,
        config: {
          category: 'ajaxError',
        },
      })
    } catch (e) {
      console.error(e)
    }
    return Promise.reject(err)
  }
)

export default instance
